import { render, staticRenderFns } from "./vcSelectTransaction.vue?vue&type=template&id=1b1c8c7c&"
import script from "./vcSelectTransaction.vue?vue&type=script&lang=js&"
export * from "./vcSelectTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports